import React, { VFC, ReactNode, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Auth } from '@prime/auth';

export interface AuthProviderProps {
  OAuthClient: Auth;
  children?: ReactNode;
}

const AuthProvider: VFC<AuthProviderProps> = ({ OAuthClient, children }) => {
  const [authenticated, setAuthenticated] = useState(() => OAuthClient.isAuthenticated());

  useEffect(() => {
    OAuthClient.init().then(() => {
      setAuthenticated(OAuthClient.isAuthenticated());
    });
  }, []);

  return <>{authenticated && children}</>;
};

AuthProvider.propTypes = {
  children: PropTypes.node,
  // @ts-ignore
  OAuthClient: PropTypes.object,
};

export default AuthProvider;
